package com.anjuros.website.templates.template4.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.components.shared.FaUpRightAndDownLeftFromCenterIcon
import com.anjuros.website.templates.template4.styles.Template4GalleryMarginStyle
import com.anjuros.website.templates.template4.styles.Template4ImageSizeStyle
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.times

@Composable
fun Template4GalleryCard(galleryImage:String,index:Int,
                         animatedOpacity:Float,
                         animatedOpacityTransition:Boolean,
                         onImageClicked:(imagePath:Int)->Unit){

    Box(modifier = Template4GalleryMarginStyle.toModifier()
        .cursor(Cursor.Pointer)
        .opacity(animatedOpacity)
        .transition(Transition.of("opacity",if(animatedOpacityTransition)1000.ms else 0.ms,
            delay = if(animatedOpacityTransition) (index+1)*500.ms else 0.ms))
        .onClick { onImageClicked(index) }){
        AnjurosImage(src = galleryImage,
            alt="gallery Image",
            modifier = Template4ImageSizeStyle.toModifier()
                .objectFit(ObjectFit.Cover))


        FaUpRightAndDownLeftFromCenterIcon(modifier = Modifier.align(Alignment.TopEnd)
            .margin(top=10.px, right = 10.px).displayIfAtLeast(Breakpoint.LG).color(Colors.White),
            size = 24)
    }
}
